import { config } from "../environment";
import { useHasAccess } from "./useHasAccess";

export function useCustomDomainsEnabled() {
  const admin = useHasAccess("allow_all");
  return admin && config.customDomainsEnabled;
}
